module.exports = __webpack_public_path__ + "img/Recurso 60@300x.e087acaa.png";